import React from 'react';
import _ from 'lodash';
import { useMutation } from 'react-fetching-library';
import { Modal, Card, CardContent, CardHeader, IconButton, Stack, Alert, Button, Portal, Typography, Input } from '@mui/material';

import { sendAdditionalDocument } from '../../../../../../../services/request';

import CloseIcon from '@mui/icons-material/Close';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { SmallFormTextField } from '../../../../../../../components/small-fields/SmallFormTextField';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};


export default function DocumentForm({ open, handleClose, handleAddDocument, applicationId }) {
  const refInputFile = React.useRef(null);
  const [fileName, setFileName] = React.useState('');
  const [name, setName] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  const { loading, mutate } = useMutation(sendAdditionalDocument);

  const handleFileSelect = e => {
    if (refInputFile.current.files[0]) {
      setFileName(refInputFile.current.files[0].name);
    } else {
      setFileName(e.target.files[0].name);
    }

  };

  const handleSubmit = async () => {
    if (!_.isNil(refInputFile.current.files[0])) {
      const formData = new FormData();
      formData.append('file', refInputFile.current.files[0]);
      formData.append('file_name', refInputFile.current.files[0].name);
      formData.append('employee_application', applicationId);
      formData.append('name', name);
      formData.append('description', description);
      formData.append('added_by_staff', false);
      const { error, payload } = await mutate(formData);

      if (!error) {
        if (payload.message !== undefined) {
          setErrorMessage(payload.message);
        } else {
          handleAddDocument(payload);
          handleClose();
        }
      } else {
        setErrorMessage('Wystąpił błąd');
      }
    }
  };

  React.useEffect(() => {
    if (open === false) {
      setName('');
      setDescription('');
      setFileName('');
      setErrorMessage('');
      if (refInputFile.current != null) {
        refInputFile.current.value = null;
      }
    }
  }, [open]);

  return (
    <Portal>
      <Modal open={open} onClose={handleClose}>
        <Card sx={{ ...style, width: '500px' }}>
          <CardHeader
            title="Dodaj plik"
            action={
              <IconButton color="primary" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent>
            <Stack spacing={3} justifyContent="flex-start" alignItems="flex-start">
              <SmallFormTextField
                name="name"
                placeholder="Nazwa pliku"
                value={name}
                sx={{ width: '100%' }}
                onChange={e => setName(e.target.value)}
              />
              <SmallFormTextField
                name="description"
                placeholder="Opis pliku"
                value={description}
                sx={{ width: '100%' }}
                onChange={e => setDescription(e.target.value)}
                multiline={true}
                rows={3}
              />
              <Stack direction="row" spacing={2} alignItems="center">
                <Button variant="contained" component="label" sx={{ textAlign: 'center' }}>
                  Wczytaj plik
                  <input type="file" hidden ref={refInputFile} onChange={handleFileSelect}/>
                </Button>
                {fileName !== ''
                  ? <Stack direction="row" spacing={1}>
                    <InsertDriveFileOutlinedIcon color="primary"/>
                    <Typography variant="subtitle2">{fileName}</Typography>
                  </Stack>
                  : null}
              </Stack>
              {errorMessage !== '' ? <Alert variant="outlined" severity="error" sx={{ width: '100%' }}>{errorMessage}</Alert> : null}
              <Button variant="contained" fullWidth onClick={handleSubmit} disabled={loading}>zapisz</Button>
            </Stack>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
